import { useCallback, useState } from "react";
import { TextArea } from "@radix-ui/themes";
import styles from "./QaScore.module.scss";

interface QaScoreCommentProps {
  value?: string;
  updateScoreComment: (newValue: string) => Promise<void>;
  viewOnly?: boolean;
}

export function QaScoreComment({
  value,
  updateScoreComment,
  viewOnly = false,
}: QaScoreCommentProps) {
  const [comment, setComment] = useState(value);

  const handleBlur = useCallback(() => {
    if (comment !== value) {
      updateScoreComment(comment || "");
    }
  }, [comment, value, updateScoreComment]);

  return !viewOnly || value ? (
    <TextArea
      variant={"soft"}
      color={"gray"}
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      onBlur={handleBlur}
      className={styles.QaScoreComment}
      placeholder={"Add comment"}
      disabled={viewOnly}
    />
  ) : null;
}
